<template>
  <FormGroup
    prop="currency"
    :label="$t('form.invoiceForm.fields.currency.label')"
    floating-label
    :input-value="currency"
  >
    <Select
      class="select-v2"
      name="currency"
      v-model="currency"
      data-test="currency_input"
      filterable
      :popper-append-to-body="false"
    >
      <Option
        v-for="option in filteredCurrencyOptions"
        :key="option.key"
        :label="option.value"
        :value="option.key"
        :data-test="'currency_option_' + option.key"
      />
    </Select>
    <InputHelp
      v-if="visibilities.vat_totals_currency_conversion && vat_totals_currency_conversion"
      data-test="exchange_rate"
    >
      <div>
        {{ currentList &&
          $t('form.invoiceForm.fields.currency.rateInfo', currentList)
        }}
      </div>
    </InputHelp>
  </FormGroup>
</template>

<script>
import { mapFields } from 'vuex-map-fields';
import { mapState } from 'vuex';
import { NEW_INVOICE } from '~/config/constants';

export default {
  inject: ['invoiceType'],
  computed: {
    ...mapFields('invoiceForm', ['currency', 'conversion_rate_message', 'vat_totals_currency_conversion']),
    ...mapState('currencyRates', ['currentList']),
    ...mapState('invoiceForm', [
      'invoice',
      'visibilities',
      'tax_point_on',
    ]),
    ...mapState('config', { currencyOptions: state => state.invoice.currencies }),
    filteredCurrencyOptions() {
      if (this.invoiceType === NEW_INVOICE) {
        return this.currencyOptions.filter(option => option.key !== 'HRK');
      }
      return this.currencyOptions;
    },
  },
  watch: {
    currency(value) {
      this.$store.dispatch('invoiceForm/computeVisibilities');
      this.$store.dispatch('currencyRates/setCurrencyRate', { currency: value });
    },
    tax_point_on() {
      this.$store.dispatch('currencyRates/setCurrencyRate', { currency: this.currency });
    },
    vat_totals_currency_conversion: {
      immediate: true,
      handler(value) {
        if (value) {
          this.$store.dispatch('currencyRates/setCurrencyRate', { currency: this.currency });
        }
      },
    },
  },
};
</script>
